import ApiWrapper from "./ApiWrapper"

var UserDataService = {
    getDefaultUserDataPackage() {
        return new Promise((resolve) => {
            ApiWrapper.post('/api/UserDataPackage/GetDefaultUserDataPackage').then((response) => {
                resolve(response);
            });
        });
    }
}

export default UserDataService
